import {Component, Input, OnInit, EventEmitter, Output, OnDestroy} from '@angular/core';
import {Dealer} from '@ox/typings';

@Component({
  selector: 'webu-dealer-list',
  templateUrl: './dealer-list-webu.component.html'
})
export class DealerListWebuComponent implements OnInit, OnDestroy {

  @Input() dealer: Dealer;
  @Input() preferredDealer: Dealer;
  @Input() cmsPrefix: string;
  @Input() trackLinkPrefix: string;
  @Input() prop10Prefix: string;
  @Input() isGuestMode: boolean;
  @Output() dealerSelected = new EventEmitter();
  @Output() stateChange = new EventEmitter();

  public dealerDistance: string;
  public language = window.gm.bml?.lang;
  public isPreferred = false;
  public getScheduleServiceUrl: any;
  public dealerHideSpecialServices: boolean;
  public dealerHideScheduleServiceLink: string;

  ngOnDestroy(): void {
    this.stateChange.complete();
  }

  ngOnInit(): void {
    this.dealerDistance = this.dealer.distance.toString();
  }

  goToState(state: string) {
    this.dealerSelected.emit(this.dealer);
    if (state === 'viewDealerInfo') {
      this.stateChange.emit('viewDealerInfo');
    } else if (state === 'directions') {
      this.stateChange.emit('directions');
    } else if (state === 'goToPreferredDealer') {
      this.stateChange.emit('goToPreferredDealer');
    }
  }

  loadOss(){
    const URL = this.dealer.scheduleServiceWebSite;
    window.location.href = URL;
  }
}
